export const REALTIME_EVENT_SOURCES = [
  { value: 'parliamentlive', name: 'Westminster' },
  { value: 'senedd', name: 'Senedd' },
];

export const SENEDD_EVENT_CATEGORY = 'Business in the Welsh Parliament';

// Realtime events and utterances carry a source; calendar events only have a category
export const isSenedd = (item) =>
  item?.source === 'senedd' ||
  item?.eventCategory === SENEDD_EVENT_CATEGORY ||
  item?.eventCategoryName === SENEDD_EVENT_CATEGORY;

export const getRealtimeEventSource = (item) =>
  REALTIME_EVENT_SOURCES.find(({ value }) => value === (isSenedd(item) ? 'senedd' : 'parliamentlive'));
